var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import * as ReactDOM from 'react-dom';
var OutsideClick = (function (_super) {
    __extends(OutsideClick, _super);
    function OutsideClick(props) {
        var _this = _super.call(this, props) || this;
        _this.handleOutsideClick = function (event) {
            var onOutsideClick = _this.props.onOutsideClick;
            var element = _this.container;
            if (!event.target || !element.current) {
                return;
            }
            else {
                if (!ReactDOM.findDOMNode(element.current).contains(event.target)) {
                    onOutsideClick(event);
                }
            }
        };
        _this.container = React.createRef();
        return _this;
    }
    OutsideClick.prototype.componentDidMount = function () {
        document.addEventListener('click', this.handleOutsideClick, true);
    };
    OutsideClick.prototype.componentWillUnmount = function () {
        document.removeEventListener('click', this.handleOutsideClick);
    };
    OutsideClick.prototype.render = function () {
        var children = this.props.children;
        return React.cloneElement(React.Children.only(children), {
            ref: this.container,
        });
    };
    return OutsideClick;
}(React.Component));
export default OutsideClick;
//# sourceMappingURL=OutsideClick.js.map